import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=9226a562"
import script from "./roleManagement.vue?vue&type=script&lang=js"
export * from "./roleManagement.vue?vue&type=script&lang=js"
import style0 from "./roleManagement.vue?vue&type=style&index=0&id=9226a562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_30effc9705e4bf7ead9172d765b7e483/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports